import { useMutation } from 'react-query';
import { AxiosError } from 'axios';

import { recordHsaBulkTransferInfo } from 'apis/hsaBulkTransfer';
import { MemberHsaTransferType } from 'constants/hsaBulkTransfer';

/**
 * Used to record hsa bulk transfer member decision
 */
const useMutationHsaBulkTransfer = ({
  onSuccess,
  onError,
}: {
  onSuccess?: ({
    data,
  }: {
    data: {
      companyId: string;
      companyPlanId: string;
      createdAt: string;
      custodianName: string;
      employeeId: string;
      id: string;
      transferType: MemberHsaTransferType;
      updatedAt: string;
    };
  }) => void;
  onError?: (e: AxiosError) => void;
}) => {
  const { mutate, isLoading } = useMutation(
    ({
      payload,
    }: {
      payload: {
        custodianName: string;
        transferType: MemberHsaTransferType;
        transferDeadline?: string;
      };
    }) => recordHsaBulkTransferInfo({ payload }),
    { onSuccess, onError }
  );

  return { mutate, isLoading };
};

export default useMutationHsaBulkTransfer;
